const SEARCH_CRAWLERS = [
  'bingpreview',
  'bot',
  'chrome-lighthouse',
  'contentkingbot',
  'crawler',
  'crawling',
  'google-inspectiontool',
  'googlebot',
  'googleother',
  'lighthouse', // lighthouse crawls to simulate GSC, adding to search crawlers
  'prerender',
  'robot',
  'spider',
  'yandex',
];

export const isSearchCrawler = (headers: any): boolean => {
  return (
    headers?.['cf-verified-bot'] ||
    SEARCH_CRAWLERS.some((crawler) =>
      headers?.['user-agent']?.toLowerCase()?.includes(crawler.toLowerCase()),
    )
  );
};
